import {TextureLoader, type ShapePath} from 'three'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader'
import {SVGLoader} from 'three/examples/jsm/loaders/SVGLoader'

type GLTFAsset = {
  src: string
  scene: THREE.Group | null
}

type ImageAsset = {
  src: string
  texture: THREE.Texture | null
  flipY: boolean
}

type SVGAsset = {
  src: string
  paths: ShapePath[] | null
}
class Assets {
  gltfs: Record<string, GLTFAsset>
  images: Record<string, ImageAsset>
  svgs: Record<string, SVGAsset>
  constructor() {
    const imagePath = '/images/modules/site/security-hero/'
    this.gltfs = {
      shield: {
        src: `${imagePath}/shield.glb`,
        scene: null,
      },
    }

    this.images = {
      matcap4: {
        src: `${imagePath}textures/matcap4.jpg`,
        texture: null,
        flipY: true,
      },
    }

    this.svgs = {
      gitlines1: {
        src: `${imagePath}nodes/s-gitlines1.svg`,
        paths: null,
      },
      gitlines2: {
        src: `${imagePath}nodes/s-gitlines2.svg`,
        paths: null,
      },
    }
  }

  load(callback: () => void) {
    const allPromisess = [...this.loadImages(), ...this.loadGltfs(), ...this.loadSvgs()]

    Promise.all(allPromisess)
      // eslint-disable-next-line github/no-then
      .then(() => {
        // All assets loaded
        if (callback) callback()
      })
    // .catch(error => {
    //   console.log('An error occurred', error)
    // })
  }

  loadGltfs() {
    const loader = new GLTFLoader()

    const promises = Object.values(this.gltfs).map(
      gltf =>
        new Promise((resolve, reject) => {
          loader.load(
            gltf.src,
            loadedGltf => {
              gltf.scene = loadedGltf.scene
              resolve(loadedGltf.scene)
            },
            undefined,
            error => reject(error),
          )
        }),
    )

    return promises
  }

  loadImages() {
    const loader = new TextureLoader()

    const promises = Object.values(this.images).map(
      image =>
        new Promise((resolve, reject) => {
          loader.load(
            image.src,
            texture => {
              image.texture = texture
              texture.flipY = image.flipY
              resolve(texture)
            },
            undefined,
            error => reject(error),
          )
        }),
    )

    return promises
  }

  loadSvgs() {
    const loader = new SVGLoader()

    const promises = Object.values(this.svgs).map(
      svg =>
        new Promise(resolve => {
          interface Data {
            paths: ShapePath[]
            xml: XMLDocument
          }
          loader.load(svg.src, (data: Data) => {
            const paths = data.paths
            svg.paths = paths
            resolve(paths)
          })
        }),
    )

    return promises
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new Assets()
